import {connect} from "react-redux";

const Messages_Room_Window_Message = (props) => {
    const {user_from,user_to,content} = props;
    const {second_user} = props;
    return (user_from == second_user.id) ?
    (
        <div className="messages_room_message_leftUser">
            <div className={`messages_room_message background_color_text_${props.color_background} background_change_${props.color_background}`}>{content}</div>
        </div>
    ) :
    (
        <div className="messages_room_message_rightUser">
            <div className={`messages_room_message profile_customize_section_color_button_${props.color_button}`}>{content}</div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        room: state.getRoom.room,
        room_messages: state.getRoomMessages.room_messages,
        color_button: state.getColorButton.color_button,
        second_user: state.getSecondUser.second_user,
        color_background: state.getColorBackground.color_background
    }
}
export default connect(mapStateToProps)(Messages_Room_Window_Message);